<template>
  <v-loading v-if="loading" :opaque="opaqueLoading" />
  <v-card outlined :class="getCSSClass" v-else>
    <v-toolbar
      :color="$app.opts.toolbarHeaderColor"
      :dark="$app.opts.toolbarHeaderDark"
      flat
      dense
      v-if="enableToolbar"
    >
      <v-toolbar-title>
        <slot name="title">Title</slot>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <slot name="header-actions"></slot>
    </v-toolbar>

    <v-divider v-if="enableToolbar && headerSeparator"></v-divider>

    <slot name="alert"></slot>

    <v-card-text :class="contentClass" v-if="enableContent">
      <slot name="content"></slot>
    </v-card-text>
    <v-divider v-if="enableFooterActions && footerSeparator"></v-divider>
    <v-card-actions class="justify-end" v-if="enableFooterActions">
      <slot name="footer-actions"></slot>
    </v-card-actions>
    <div class="no-footer" v-if="!enableFooterActions"></div>
  </v-card>
</template>

<script>
import VLoading from './VLoading'

export default {
  name: 'VWidget',
  components: { VLoading },
  props: {
    loading: { type: Boolean, default: false },
    opaqueLoading: { type: Boolean, default: false },
    enableToolbar: { type: Boolean, default: true },
    enableFooterActions: { type: Boolean, default: false },
    enableContent: { type: Boolean, default: true },
    contentClass: { type: String, default: 'white' },
    headerSeparator: { type: Boolean, default: true },
    footerSeparator: { type: Boolean, default: true },
    cssClass: { type: String, default: '' }
  },
  computed: {
    getCSSClass() {
      const base = ['VWidget']
      return [...base, ...this.cssClass.split(' ')]
    }
  }
}
</script>

<style scoped lang="scss">
.VWidget {
  .v-toolbar {
    ::v-deep .v-toolbar__content {
      padding: 0 16px;

      .v-btn--icon {
        margin-right: 0;
        margin-left: 0;
      }
    }
  }

  .no-footer {
    padding: 1px;
  }
}
</style>
